import { gql } from '@apollo/client'

export const TaskSettingDetailsFragment = gql`
  fragment TaskSettingDetails on SystemTaskSetting {
    taskRelatedTo
    taskCaption
    interval
  }
`
